module.exports = __webpack_public_path__ + "img/Folded_Paper_kiosk-test-blur.e34214eb.png";